import { render, staticRenderFns } from "./LastContact.vue?vue&type=template&id=6c7c82f0&"
import script from "./LastContact.vue?vue&type=script&lang=js&"
export * from "./LastContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports